import { Check } from "lucide-react";
import { WhatsAppCta } from "../components/WhatsAppCta";
import { useSeo } from "../lib/useSeo";

// Pagina estatica de proposito (decisao tomada com o usuario), nao busca da API - precos
// confirmados pelo usuario. SMS ainda nao tem gateway real conectado (ver CLAUDE.md), por isso
// os pacotes aparecem como "Em breve" em vez de contratavel.
const SMS_PACKAGES = ["1.000", "2.000", "3.000", "5.000", "10.000"];

const INCLUDED = [
  "Campanhas ilimitadas no período contratado",
  "Importação de planilha com mapeamento de colunas",
  "Agendamento, pausa e retomada de campanhas",
  "Dashboard com relatório de enviados/entregues/lidos/falhas",
  "Vários usuários por empresa",
  "Suporte via WhatsApp",
];

export function Pricing() {
  useSeo({
    title: "Planos e precos",
    description: "Precos da SendCube: plano de campanhas de WhatsApp a partir de R$ 119,90/mes.",
    path: "/planos",
  });

  return (
    <>
      <section className="mx-auto max-w-6xl px-5 pb-10 pt-14 text-center md:pt-20">
        <h1 className="text-4xl font-extrabold md:text-5xl">Apenas um plano, sem burocracias</h1>
        <p className="mx-auto mt-5 max-w-[56ch] text-lg text-ink/70">
          Um único plano, com tudo que você precisa para rodar campanhas de WhatsApp de verdade.
        </p>
      </section>

      <section className="mx-auto max-w-4xl px-5 pb-14">
        <div className="rounded-2xl border-2 border-ink bg-white p-8 shadow-solid">
          <div className="flex flex-col items-center gap-2 text-center">
            <span className="text-sm font-bold uppercase tracking-wide text-brand-600">
              Plano SendCube
            </span>
            <p className="text-sm font-medium text-ink/50">A partir de</p>
            <div className="flex items-baseline gap-1">
              <span className="text-lg font-bold">R$</span>
              <span className="text-5xl font-extrabold">119,90</span>
              <span className="text-ink/50">/mês</span>
            </div>
          </div>

          <ul className="mt-8 space-y-3">
            {INCLUDED.map((item) => (
              <li key={item} className="flex items-start gap-2 text-sm">
                <Check size={18} className="mt-0.5 flex-shrink-0 text-brand-600" />
                {item}
              </li>
            ))}
          </ul>

          <div className="mt-8 flex justify-center">
            <WhatsAppCta message="Ola! Quero contratar um plano da SendCube.">
              Contratar agora
            </WhatsAppCta>
          </div>
        </div>
      </section>

      <section className="border-t-2 border-ink bg-white py-14">
        <div className="mx-auto max-w-4xl px-5">
          <h2 className="text-center text-2xl font-bold">Pacotes de SMS (opcional)</h2>
          <p className="mx-auto mt-2 max-w-[50ch] text-center text-ink/60">
            Créditos mensais, somados ao valor do seu plano.
          </p>

          <div className="mt-8 overflow-x-auto rounded-2xl border-2 border-ink">
            <table className="w-full text-left text-sm">
              <thead className="bg-ink text-white">
                <tr>
                  <th className="px-4 py-3 font-bold">Créditos por mês</th>
                  <th className="px-4 py-3 font-bold">Valor</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-ink/10 bg-paper text-ink/40">
                {SMS_PACKAGES.map((credits) => (
                  <tr key={credits}>
                    <td className="px-4 py-3">{credits} SMS</td>
                    <td className="px-4 py-3 text-xs font-bold uppercase tracking-wide">Em breve</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="border-t-2 border-ink bg-ink py-14 text-center text-white">
        <div className="mx-auto max-w-2xl px-5">
          <h2 className="text-2xl font-bold">Dúvidas em qual configuração escolher?</h2>
          <p className="mt-2 text-white/70">
            Fale conosco que ajudamos a escolher a melhor opção
            
          </p>
          <div className="mt-6 flex justify-center">
            <WhatsAppCta message="Ola! Quero ajuda pra escolher o plano certo na SendCube.">
              Falar no WhatsApp
            </WhatsAppCta>
          </div>
        </div>
      </section>
    </>
  );
}
